const KEY = "hireside_traffic_source";
const SOURCES = { linkedin:"LinkedIn", facebook:"Facebook", fb:"Facebook", whatsapp:"WhatsApp", wa:"WhatsApp", x:"X", twitter:"X", instagram:"Instagram", tiktok:"TikTok", google:"Google", bing:"Bing", indeed:"Indeed", glassdoor:"Glassdoor", reddit:"Reddit", youtube:"YouTube", telegram:"Telegram", pinterest:"Pinterest", snapchat:"Snapchat", threads:"Threads", yahoo:"Yahoo", duckduckgo:"DuckDuckGo", direct:"Direct" };
const DOMAINS = { LinkedIn:["linkedin.com","lnkd.in"], Facebook:["facebook.com","fb.com","fb.me"], WhatsApp:["whatsapp.com","wa.me"], X:["x.com","twitter.com","t.co"], Instagram:["instagram.com"], TikTok:["tiktok.com"], Google:["google."], Bing:["bing.com"], Indeed:["indeed.com"], Glassdoor:["glassdoor.com"], Reddit:["reddit.com"], YouTube:["youtube.com","youtu.be"], Telegram:["telegram.org","t.me"], Pinterest:["pinterest.com"], Snapchat:["snapchat.com"], Threads:["threads.net"], Yahoo:["yahoo.com"], DuckDuckGo:["duckduckgo.com"] };

export const normalizeTrafficSource = value => typeof value === "string" ? SOURCES[value.trim().toLowerCase()] || null : null;

const referrerSource = referrer => {
  if (!referrer) return null;
  try {
    const host = new URL(referrer).hostname.toLowerCase().replace(/^www\./, "");
    return Object.entries(DOMAINS).find(([, domains]) => domains.some(domain => domain.endsWith(".") ? host.startsWith(domain) : host === domain || host.endsWith(`.${domain}`)))?.[0] || null;
  } catch { return null; }
};

export const captureTrafficSource = (search = "", referrer = "") => {
  let query = null;
  try { query = normalizeTrafficSource(new URLSearchParams(search).get("source")); } catch {}
  let previous = null;
  try { previous = normalizeTrafficSource(window.sessionStorage.getItem(KEY)); } catch {}
  const source = referrerSource(referrer) || query || previous || "Direct";
  try { window.sessionStorage.setItem(KEY, source); } catch {}
  return source;
};

export const getCapturedTrafficSource = () => {
  try { return normalizeTrafficSource(window.sessionStorage.getItem(KEY)) || "Direct"; } catch { return "Direct"; }
};

export const addTrafficSourceToUrl = (value, source) => {
  if (!value || !normalizeTrafficSource(source)) return value;
  try {
    const url = new URL(value, typeof window !== "undefined" ? window.location.origin : "https://hireside.com");
    url.searchParams.set("source", source.trim().toLowerCase());
    return /^https?:\/\//i.test(value) ? url.toString() : `${url.pathname}${url.search}${url.hash}`;
  } catch { return value; }
};
